if (document.querySelector('.accordion')) {
  let acc = new Accordion('.accordion');
  acc.open(0);
}

// const productSwiper = new Swiper('.product-swiper', {
//   loop: true,
//   breakpoints: {
//     320: {
//       slidesPerView: 1,
//       spaceBetween: 40
//     },
//     768: {
//       slidesPerView: 1,
//       spaceBetween: 40
//     },
//   },
//   pagination: {
//     el: '.product-swiper-pagination',
//   },

//   // Navigation arrows
//   navigation: {
//     nextEl: '.product-swiper-button-next',
//     prevEl: '.product-swiper-button-prev',
//   },
// });

const COMPANION_MAIN_TO_SUB_VARIANT = {
  // core
  47733493989622: 50453354414326,
  // flow
  49109961572598: 50344849965302,
  // glow
  49109962555638: 50453354512630,
  // kids
  49109962719478: 50453354774774,
};

const COMPANION_DEBUG = false; 

const manageCart = {
  init() {
    this.cartButton = document.getElementById('addToCart');
    this.asideCart = document.getElementById('asideCart');
    this.cartAllItems = document.getElementById('cartAllItems');
    this.cartFullPrice = document.getElementById('cartFullPrice');
    this.cartFreeShipping = document.getElementById('cartFreeShipping');
    this.cartTotalDiscount = document.getElementById('cartTotalDiscount');
    // this.cartTotalFreeItem = document.getElementById('cartTotalFreeItem');
    this.cartTotalDiscountValue = document.getElementById('cartTotalDiscountValue');
    this.cartOriginalPrice = document.getElementById('cartOriginalPrice');
    this.cartItemsList = document.getElementById('cartItemsList');
    this.cartButtonMain = document.getElementById("product_main_button");
    this.cartButtonMainPrice = document.getElementById('product_main_button_price');
    this.cartOtherProductCarousel = document.getElementById('other_products_cart');
    this.bonusFirst = document.querySelector('.bonus-1');
    this.cartBusy = false;
    this.combineProduct = document.getElementById('combineProducts');

    this.variantInputs = document.querySelectorAll('.variant_label input');

    const checkedInput = document.querySelector('.variant_label input:checked');
    if (checkedInput) {
      this.updateVariant.call(this, checkedInput);
    }

    this.addEventListeners();
    this.updateCartDisplay();
  },

  updateVariant(input) {
    const label = input.closest('.variant_label');
    const variantPrice = input.dataset.variantPrice;
    this.cartButtonMain.dataset.quantity = label.dataset.cartQuantity;
    this.cartButtonMainPrice.textContent = ' - ' + variantPrice;
  },

  addEventListeners() {
    if (this.cartButton) {
      this.cartButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.addToCart(this.cartButton);
      });
    }

    this.variantInputs.forEach(input => {
      input.addEventListener('change', () => this.updateVariant.call(this, input));
    });

    document.querySelectorAll('.addOtherToCart').forEach(button => {
      button.onclick = (event) => {
        event.preventDefault();
        const variantId = button.dataset.variantId;
        const quantity = parseInt(button.dataset.quantity || '1', 10);
        if (variantId) {
          this.addToCart(button, { id: variantId, quantity });
        } else {
          console.error('Missing data-variant-id on .addOtherToCart button');
        }
      };
    });

    if (this.asideCart) {
      document.body.addEventListener('click', (event) => {
        if (event.target.classList.contains('close-cart')) {
          document.body.classList.remove("overflow-hidden");
          this.toggleCart(false);
        } else if (event.target.classList.contains('open-cart')) {
          this.toggleCart(true);
          document.body.classList.add("overflow-hidden");
        } else if (
          event.target.classList.contains('cart-item--remove') ||
          event.target.classList.contains('cart-item--add') ||
          event.target.classList.contains('cart-item--sub')
        ) {
          this.handleQuantityChange(event);
        }
      });
    }
  },

  async addToCart(button = null, customProduct = null) {
    button?.classList.add('button--loading');
    try {
      let response;
      if (customProduct) {
        response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(customProduct),
        });
      } else {
        const addToCartForm = document.querySelector('form[action$="/cart/add"]');
        const formData = new FormData(addToCartForm);
        response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          body: formData,
        });
      }
      if (!response.ok) throw new Error('Add to cart failed');
      await this.updateCartDisplay(true);
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      button?.classList.remove('button--loading');
    }
  },

  async updateCartDisplay(openCart = false) {
    
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      let data = await response.json();
      data = await this.syncCompanionLineItems(data);
      this.updateCartUI(data);
      this.reloadCarousel(data);
      if (openCart) {
        document.body.classList.add("overflow-hidden");
        this.toggleCart(true);
      }
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  },

  reloadCarousel(cart) {
    const cartHandles = cart.items.map(item => item.handle);
    const slides = document.querySelectorAll('#other_products_cart .splide__slide');
    slides.forEach(slide => {
      const handle = slide.querySelector('a')?.getAttribute('href')?.split('/').pop();
      if (!handle) return;
      if (cartHandles.includes(handle)) {
        slide.style.display = 'none';
      } else {
        slide.style.display = 'block';
      }
    });
    const visibleSlides = Array.from(slides).filter(slide => slide.style.display !== 'none');
    const carousel = document.getElementById('other_products_cart');
    if (carousel) {
      carousel.style.display = visibleSlides.length > 0 ? 'block' : 'none';
    }
    if (window.otherProductsSplide) {
      window.otherProductsSplide.refresh();
    }
  },

  async syncCompanionLineItems(cart) {
    const map = COMPANION_MAIN_TO_SUB_VARIANT;
    const pairs = Object.entries(map).filter(([m, s]) => m != null && s != null);
    if (!pairs.length) return cart;

    const subForMain = (vid) => {
      const n = Number(vid);
      const sub = map[n] ?? map[String(n)];
      return sub != null ? Number(sub) : null;
    };

    const mainVariantIds = new Set(pairs.map(([m]) => Number(m)));
    const subVariantIds = new Set(pairs.map(([, s]) => Number(s)));

    const mainQty = {};
    const mainProductIds = new Set();
    for (const item of cart.items) {
      if (!mainVariantIds.has(Number(item.variant_id))) continue;
      const v = Number(item.variant_id);
      mainQty[v] = (mainQty[v] || 0) + item.quantity;
      if (item.quantity > 0) mainProductIds.add(Number(item.product_id));
    }
    const allowCompanionSubs = mainProductIds.size >= 2;
    const desiredSubQty = {};
    for (const subId of subVariantIds) desiredSubQty[subId] = 0;
    if (allowCompanionSubs) {
      for (const [mainVid, qty] of Object.entries(mainQty)) {
        const subId = subForMain(mainVid);
        if (subId && subVariantIds.has(subId)) {
          desiredSubQty[subId] = qty > 0 ? 1 : 0;
        }
      }
    }

    if (COMPANION_DEBUG) {
      console.log('[companion] cart variant_ids:', cart.items.map((i) => i.variant_id));
      console.log('[companion] mainQty:', mainQty);
      console.log('[companion] desiredSubQty:', desiredSubQty);
    }

    const linesBySub = {};
    for (const item of cart.items) {
      const vid = Number(item.variant_id);
      if (!subVariantIds.has(vid)) continue;
      if (!linesBySub[vid]) linesBySub[vid] = [];
      linesBySub[vid].push({ key: item.key, quantity: item.quantity });
    }

    const updates = {};
    const itemsToAdd = [];

    for (const subId of subVariantIds) {
      const desired = desiredSubQty[subId] || 0;
      const lines = linesBySub[subId] || [];

      if (!lines.length) {
        if (desired > 0) itemsToAdd.push({ id: subId, quantity: desired });
        continue;
      }
      if (desired === 0) {
        for (const L of lines) {
          if (L.quantity !== 0) updates[L.key] = 0;
        }
        continue;
      }
      if (lines[0].quantity !== desired) updates[lines[0].key] = desired;
      for (let i = 1; i < lines.length; i++) {
        if (lines[i].quantity !== 0) updates[lines[i].key] = 0;
      }
    }

    const root = window.Shopify.routes.root;
    const hasUpdates = Object.keys(updates).length > 0;
    const hasAdds = itemsToAdd.length > 0;

    if (COMPANION_DEBUG) {
      console.log('[companion] hasUpdates', hasUpdates, updates);
      console.log('[companion] hasAdds', hasAdds, itemsToAdd);
    }

    if (!hasUpdates && !hasAdds) return cart;

    try {
      if (hasUpdates) {
        const r = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });
        if (!r.ok) console.error('[companion] update.js', r.status, await r.text());
      }
      if (hasAdds) {
        const r = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd }),
        });
        if (!r.ok) console.error('[companion] add.js', r.status, await r.text());
      }
      const r2 = await fetch(`${root}cart.js`);
      if (!r2.ok) return cart;
      return await r2.json();
    } catch (e) {
      console.error('Companion sync failed:', e);
      return cart;
    }
  },

  updateCartUI(data) {

    let isOnlyAccesorry = true;
    let dataTotalPrice = (data.total_price / 100);
    let decimalPrice = (data.total_price / 100).toLocaleString("cs-CZ", { minimumFractionDigits: 0 });
    let originalPrice = (data.original_total_price / 100).toLocaleString("cs-CZ", { minimumFractionDigits: 0 });
    let totalDiscount = (data.total_discount / 100).toLocaleString("cs-CZ", { minimumFractionDigits: 0 });
    let itemsCount = 0;

    data.items.forEach(element => {
      if (element.handle != 'odmerka' && element.handle != 'sample-kit') {
        isOnlyAccesorry = false;
        itemsCount += element.quantity;
      }
    });

    if( itemsCount > 0) {
      this.combineProduct.classList.remove('hidden');
    }
    else {
      this.combineProduct.classList.add('hidden');
    }

    if (isOnlyAccesorry) {
      this.bonusFirst.classList.add('not-possible');
    } else {
      this.bonusFirst.classList.remove('not-possible');
    }

    // if (totalDiscount < 1 || itemsCount > 3) {
    //   this.cartTotalDiscount.classList.add('hidden');
    // } else {
    //   this.cartTotalDiscount.classList.remove('hidden');
    // }

    itemsCount > 0 ? this.cartOtherProductCarousel.classList.remove('hidden') : this.cartOtherProductCarousel.classList.add('hidden');
    totalDiscount > 1 ? this.cartTotalDiscount.classList.remove('hidden') : this.cartTotalDiscount.classList.add('hidden');
    // totalDiscount > 1 ? this.cartTotalFreeItem.classList.remove('hidden') : this.cartTotalFreeItem.classList.add('hidden');
    totalDiscount < 1 ? this.cartOriginalPrice.classList.add('hidden') : this.cartOriginalPrice.classList.remove('hidden');

    dataTotalPrice > window.SHIPPING_RATE ? this.cartFreeShipping.classList.remove('hidden') : this.cartFreeShipping.classList.add('hidden');
    const currency = data.currency === 'CZK' ? 'Kč' : data.currency;
    this.cartTotalDiscountValue.textContent = `${totalDiscount} ${currency}`;
    // this.cartOriginalPrice.textContent = `${originalPrice} ${data.currency.toUpperCase()}`;
    this.cartOriginalPrice.textContent = `${originalPrice} ${currency}`;
    this.cartFullPrice.textContent = `${decimalPrice} ${currency}`;
    this.cartAllItems.textContent = data.item_count;
    this.setCartIcon(data.item_count);
    this.changeProgresLine(itemsCount);
  },

  setCartIcon(count) {
    const cartCount = document.getElementById("cartIconCount");
    const cartButton = document.getElementById("checkoutButton");
    cartCount.textContent = count;
    cartCount.classList.toggle('hide', count === 0);
    cartButton.classList.toggle('deactivated', count === 0);
  },

  changeProgresLine(count) {
    const progressCart = document.getElementById('progressCart');
    if (count > 6) {
      progressCart.dataset.count = 'max';
    }
    if (count <= 6) {
      progressCart.dataset.count = count;
    }
  },

  toggleCart(show) {
    this.asideCart.classList.toggle('opened', show);
    if (show) this.refetchCartItems();
  },

  async refetchCartItems() {
    try {
      const response = await fetch('/?sections=custom-cart-items');
      const data = await response.json();
      this.cartItemsList.innerHTML = data['custom-cart-items'].trim();
    } catch (error) {
      console.error('Error refetching cart items:', error);
    }
  },

  handleQuantityChange(event) {
    if (this.cartBusy) return;
    this.cartBusy = true;
    event.target.classList.add('cart-item--spinner');
    const itemId = event.target.getAttribute('key');
    const itemValue = event.target.getAttribute('data-val') || 0;
    this.changeQuantity(itemId, itemValue);
  },

  async changeQuantity(id, qty) {
    const updates = { [id]: qty };
    try {
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      await this.updateCartDisplay(this.asideCart.classList.contains('opened'));
    } catch (error) {
      console.error('Error updating cart quantity:', error);
    } finally {
      this.cartBusy = false;
    }
  },
};

// Initialize the cart on page load
document.addEventListener('DOMContentLoaded', () => manageCart.init());
// let mainNavigation = {
//   init: function() {
//     let userButton = document.getElementById('userButton');
//     let loginPopup = document.getElementById('loginPopup')

//     userButton.addEventListener('click', function(){
//       loginPopup.classList.toggle('hidden');
//     })
//   }
// }

const mobileNavigation = { 
  init: function() {
    const toggleNav = document.getElementById('toggleNav');
    const navMobile = document.getElementById('navMobile');
    document.getElementById('toggleNav').addEventListener('click', function() {
      toggleNav.classList.toggle('is-active');
      navMobile.classList.toggle('is-active');
      document.body.classList.toggle("overflow-hidden");
    })
  }
}

let popups = {
  init: function () {
    const ingredientsPopup = document.getElementById('product-ingredients-popup');
    const ingredientsPopups = document.querySelectorAll('.product-extra-info-ac a');
    const ingredientsPopupAll = document.getElementById('product-ingredients-popup-all');
    const ingredientsPopupConent = document.getElementById('product-ingredients-popup-content');
    const preparePopup = document.getElementById('product-prepare-popup');
    const preparePopupConent = document.getElementById('product-prepare-popup-content');
    const closePopup = document.getElementById('popup-close');

    if (preparePopup) {
      preparePopup.addEventListener('click', () => {
        Swal.fire({
          html: preparePopupConent.innerHTML,
          showConfirmButton: false,
          width: "1220",
          showCloseButton: true,
          showClass: {
            popup: `
                    animate__animated
                    animate__fadeInUp
                    animate__faster
                  `
          },
          hideClass: {
            popup: `
                    animate__animated
                    animate__fadeOutDown
                    animate__faster
                  `
          }
        });
      })
    }

    const openIngredientsPopup = () => {
      Swal.fire({
        html: ingredientsPopupConent.innerHTML,
        showConfirmButton: false,
        width: "1320px",
        showCloseButton: true,
        showClass: {
          popup: `
                    animate__animated
                    animate__fadeInUp
                    animate__faster
                  `
        },
        hideClass: {
          popup: `
                    animate__animated
                    animate__fadeOutDown
                    animate__faster
                  `
        }
      });
    }

    if( ingredientsPopups.length > 0) {
      ingredientsPopups.forEach(element => {

        if( element.getAttribute('href') === "#open-popup") {
          element.addEventListener('click', (e) => {
              e.preventDefault(); 
              openIngredientsPopup();
            })
        }
      });
    }

    if (ingredientsPopup) {
      ingredientsPopup.addEventListener('click', () => openIngredientsPopup())
    }
    if (ingredientsPopupAll) {
      ingredientsPopupAll.addEventListener('click', () => openIngredientsPopup())
    }
  }
}


addEventListener("load", (event) => {
  manageCart.init();
  popups.init();
  mobileNavigation.init();
});

let isScrolled = false;
let isProductBarVisible = false;
const productBar = document.getElementById('header_products_bar');
gsap.registerPlugin(ScrollTrigger);
window.addEventListener("scroll", () => {
  // if (window.scrollY > 700 && !isScrolled) {
  //   isScrolled = true;
  //   gsap.to(".product-button", { backgroundColor: "#17392b", color: "#fff", duration: 0.5,"--product-button-after": "#ffffff" });
  // } else if (window.scrollY <= 700 && isScrolled) {
  //   isScrolled = false;
  //   gsap.to(".product-button", { backgroundColor: "#fdfcfb", color: "#17392b", duration: 0.5, "--product-button-after": "#17392b" });
  // }


    const productDetailSection = document.querySelector('.product-detail');
    const scrollOffset = 300;
    if( productDetailSection) {
      const scrollDistance = productDetailSection.offsetTop + productDetailSection.offsetHeight - scrollOffset;
      if (window.scrollY > scrollDistance && !isProductBarVisible) {
        isProductBarVisible = true;
        productBar?.classList.remove('hidden');
        // gsap.to(".product-button", { backgroundColor: "#17392b", color: "#fff", duration: 0.5,"--product-button-after": "#ffffff" });
      } else if (window.scrollY <= scrollDistance && isProductBarVisible) {
        isProductBarVisible = false;
        productBar?.classList.add('hidden');
        // gsap.to(".product-button", { backgroundColor: "#fdfcfb", color: "#17392b", duration: 0.5, "--product-button-after": "#17392b" });
      }
    }
    

});

const headerProductsOptionsClose = document.getElementById('header-products-options-close');
const headerProductsCheckbox = document.getElementById('header_products_checkbox');

headerProductsOptionsClose?.addEventListener('click', () => {
  headerProductsCheckbox.checked = false;
});

document.addEventListener("DOMContentLoaded", function() {
  if (window.location.hash === "#reviews") {
    gsap.to(window, { 
      duration: 1.2,
      delay: 0.5,
      scrollTo: { y: "#recenzie", offsetY:50 },
      onComplete: function() {
        // Remove the hash from the URL
        history.replaceState(null, null, window.location.pathname);
      } 
    });
  }
});

const scrollToButtons = document.querySelectorAll('.scroll-to-section');
scrollToButtons.forEach(element => {
  element.addEventListener('click', (e) => {
    e.preventDefault();
    const scrollToId = element.getAttribute('href').replace("#", "");
    const scrollSection = document.getElementById( scrollToId );
    if( scrollSection ) {
      gsap.to(window, { 
      duration: 1.2,
      scrollTo: { y: scrollSection, offsetY:80 },
      onComplete: function() {
        // Remove the hash from the URL
        history.replaceState(null, null, window.location.pathname);
      } 
    });
    }
  })
});

const parentDiv = document.querySelector('.section.reviews');
if( parentDiv ) {
  parentDiv.addEventListener('click', function(event) {
    if (event.target && event.target.matches('.jdgm-rev__pic-img')) {
      event.target.classList.add('hidden');
      setTimeout(() => {
        event.target.classList.remove('hidden');
        window.dispatchEvent(new Event('resize'));
      }, 100);
    }
  });
}

const flashMessage = document.getElementById('flash-message');
const flashToggle = document.getElementById('flash-toggle');
document.addEventListener("DOMContentLoaded", function() {
  checkFlashMessageVisibility();
});

const checkFlashMessageVisibility = () => {
  if ( flashToggle && sessionStorage.getItem('flashMessage') != 'false' ) {
    flashMessage.classList.add('flash-visible');
  }
}

if(flashToggle) {
  flashToggle.addEventListener('click', function() {
    flashMessage.classList.remove('flash-visible');
    sessionStorage.setItem('flashMessage', 'false');
  })
}

